/**
 * Wachtwoordmanagers (1Password, LastPass, Bitwarden) weghouden van gewone velden.
 *
 * Wiki-feedback Algemeen (26 sep): "Waarom krijg ik hier een 1Password-dropdown?" —
 * 1Password ziet een dialoog met "Naam" + "URL" (shortcut maken) of een zoekveld aan
 * voor een inlogformulier en biedt "Save in 1Password" aan. Deze app logt in via
 * Microsoft (MSAL); in de app zelf staan alleen een paar echte wachtwoordvelden
 * (type="password") en die laten we ongemoeid.
 *
 * Eén keer starten in index.js: markeert alle bestaande en later toegevoegde
 * input/textarea-velden. Een veld dat wél door de manager mag, zet data-1p-allow.
 */
const MARKERINGEN = {
  'data-1p-ignore': 'true', // 1Password
  'data-lpignore': 'true', // LastPass
  'data-bwignore': 'true', // Bitwarden
  'data-form-type': 'other', // Dashlane
};

const OVERSLAAN_TYPES = new Set(['password', 'hidden', 'checkbox', 'radio', 'file', 'submit', 'button', 'range', 'color']);

export function markeerVeld(el) {
  if (!el || !el.tagName) return;
  const tag = el.tagName.toLowerCase();
  if (tag !== 'input' && tag !== 'textarea') return;
  if (tag === 'input' && OVERSLAAN_TYPES.has((el.getAttribute('type') || 'text').toLowerCase())) return;
  if (el.hasAttribute('data-1p-allow')) return;
  Object.entries(MARKERINGEN).forEach(([k, v]) => { if (!el.hasAttribute(k)) el.setAttribute(k, v); });
  // Browser-autofill (adres, naam) hoort ook niet op zoek-/invulvelden van de tool.
  if (!el.hasAttribute('autocomplete')) el.setAttribute('autocomplete', 'off');
}

export function markeerBinnen(root) {
  if (!root) return;
  if (root.nodeType === 1) {
    markeerVeld(root);
    if (root.querySelectorAll) root.querySelectorAll('input, textarea').forEach(markeerVeld);
  }
}

/** Start de observer; geeft een stop-functie terug (handig in tests). */
export function startGeenWachtwoordmanager(doc = typeof document !== 'undefined' ? document : null) {
  if (!doc || !doc.body || typeof MutationObserver === 'undefined') return () => {};
  markeerBinnen(doc.body);
  const obs = new MutationObserver((mutaties) => {
    mutaties.forEach((m) => {
      if (m.type === 'childList') m.addedNodes.forEach(markeerBinnen);
      else if (m.type === 'attributes') markeerVeld(m.target); // type gewijzigd (bijv. tonen/verbergen)
    });
  });
  obs.observe(doc.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['type'] });
  return () => obs.disconnect();
}
